<div
  class="layout-sidebar"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="sidebar-header h-5rem">
    <a [routerLink]="['/']" class="logo">
      <div class="logo-image w-full flex justify-content-center">
        <img
          [src]="theme.configValue.mainLogoContrastUrl"
          class="tactiq-logo"
          alt="Tactiq logo"
        />
      </div>
    </a>
  </div>

  <twx-retailer-sidebar-card></twx-retailer-sidebar-card>

  <div #menuContainer class="layout-menu-container">
    <twx-menu></twx-menu>
  </div>

  <div class="sidebar-footer">
    <img [src]="'assets/logos/tactiq-patent-pending.svg'" alt="Tactiq logo" />
    <p>Patent Pending</p>
    @if (!previewMode) {
      <twx-button
        label="Sign Out"
        icon="pi pi-sign-out"
        styleClass="bg-white text-primary gap-0"
        class="mt-3"
        [severity]="null"
        (buttonClicked)="logout()"
      ></twx-button>
    }
  </div>
</div>
